import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import useUserStyle from './UserStyle';

const User: FC = () => {
  const classes = useUserStyle();
  return (
    <>
      <div className={classes.container}>
        <Outlet />
      </div>
    </>
  );
};

export default User;
